import { render, staticRenderFns } from "./EduBook.vue?vue&type=template&id=7b807782&scoped=true&"
import script from "./EduBook.vue?vue&type=script&lang=js&"
export * from "./EduBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b807782",
  null
  
)

export default component.exports